import './App.scss';
import Layout from './pages/layout';

function App() {
  return (
    <Layout />
  )
}

export default App;
